import React from 'react';
import { Map, CheckCircle2 } from 'lucide-react';
export function SolutionSection() {
  return <section className="w-full bg-gradient-to-b from-navy-light to-navy py-24 px-4 border-y border-gold/20" data-id="element-137">
      <div className="max-w-5xl mx-auto text-center" data-id="element-138">
        <div className="inline-flex items-center gap-2 text-gold font-bold tracking-widest uppercase mb-6" data-id="element-139">
          <Map className="w-5 h-5" data-id="element-140" />
          <span data-id="element-141">Section 3: The Unique Mechanism</span>
        </div>

        <h2 className="text-4xl md:text-6xl font-headline font-bold text-white mb-8 leading-tight" data-id="element-142">
          I've coded the process into what I call <br data-id="element-143" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold via-yellow-200 to-gold text-glow" data-id="element-144">
            The Critical Path 8-16
          </span>
        </h2>

        <div className="max-w-3xl mx-auto text-xl text-gray-300 mb-12 leading-relaxed" data-id="element-145">
          <p className="mb-6" data-id="element-146">
            It's not a training course.{' '}
            <span className="text-white font-bold" data-id="element-147">
              It's an Intelligence Map.
            </span>
          </p>
          <p data-id="element-148">
            It's the exact same system used by families who secure $40,000/year
            scholarships or professional academy contracts, but simplified for
            the working parent who has no time to waste.
          </p>
        </div>

        <div className="bg-navy border border-gold/30 rounded-2xl p-8 md:p-12 relative overflow-hidden group hover:border-gold/60 transition-colors duration-500" data-id="element-149">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-150" />

          <p className="text-sm text-cyan font-bold uppercase tracking-[0.2em] mb-4" data-id="element-151">
            Introducing
          </p>

          <h3 className="text-3xl md:text-5xl font-headline font-bold text-white mb-6" data-id="element-152">
            THE SCHOLARSHIP PRO METHOD: <br className="md:hidden" data-id="element-153" />
            <span className="text-gold" data-id="element-154">CRITICAL PATH 8-16</span>
          </h3>

          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-155">
            The exact Blueprint to get your kid off the bench and onto the radar
            of decision-makers.
          </p>

          <div className="mt-8 flex justify-center" data-id="element-156">
            <CheckCircle2 className="w-12 h-12 text-gold opacity-80" data-id="element-157" />
          </div>
        </div>
      </div>
    </section>;
}